export default function Input({ label, error, className = '', ...props }) {
  return (
    <div className={`mb-4 ${className}`}>
      {label && <label className="block text-sm text-royal-200 mb-1 font-body">{label}</label>}
      <input
        className="w-full px-4 py-3 bg-royal-800/50 border border-royal-600 rounded-lg text-white placeholder-royal-400 focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors"
        {...props}
      />
      {error && <p className="mt-1 text-sm text-red-400">{error}</p>}
    </div>
  );
}

export function Textarea({ label, error, className = '', ...props }) {
  return (
    <div className={`mb-4 ${className}`}>
      {label && <label className="block text-sm text-royal-200 mb-1 font-body">{label}</label>}
      <textarea
        className="w-full px-4 py-3 bg-royal-800/50 border border-royal-600 rounded-lg text-white placeholder-royal-400 focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors resize-y"
        rows={4}
        {...props}
      />
      {error && <p className="mt-1 text-sm text-red-400">{error}</p>}
    </div>
  );
}

export function Select({ label, error, children, className = '', ...props }) {
  return (
    <div className={`mb-4 ${className}`}>
      {label && <label className="block text-sm text-royal-200 mb-1 font-body">{label}</label>}
      <select
        className="w-full px-4 py-3 bg-royal-800/50 border border-royal-600 rounded-lg text-white focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors"
        {...props}
      >
        {children}
      </select>
      {error && <p className="mt-1 text-sm text-red-400">{error}</p>}
    </div>
  );
}
